import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  standalone: false,
  selector: 'app-file-manager-context',
  templateUrl: './file-manager-context.component.html',
  styleUrls: ['./file-manager-context.component.css']
})
export class FileManagerContextComponent implements OnInit {

  @Input() positionX = 0;
  @Input() positionY = 0;
  @Input() clickedEmptySpace: boolean = false;
  @Input() contextMode: string;

  @Output() close = new EventEmitter<boolean>();
  @Output() upload = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  emitUpload() {
    this.upload.emit(true);
  }

  closeContext() {
    this.close.emit(true);
  }

}
